// Vite-compatible MSW initialization
export const enableMocking = async () => {
  if (
    import.meta.env.MODE !== 'development' ||
    import.meta.env.VITE_USE_MOCKS !== 'true'
  ) {
    return
  }

  const { worker } = await import('./browser')
  return worker.start({
    onUnhandledRequest: 'bypass'
  })
}
